import React from 'react'
import styled from '@emotion/styled'
import {
  theme,
  Flex,
  MultilineTruncatedText,
  Icon,
} from '@mindfulchefuk/design-system'
import { SpicinessLevel } from '@mindfulchefuk/features/Recipes/interfaces'

type TRecipeCardWithClaimsTitle = {
  title: string
  spicinessLevel: SpicinessLevel
}

const StyledMultiLine = styled(MultilineTruncatedText)`
  font-size: 22px;
  @media screen and (min-width: 640px) {
    font-size: 22px;
  }
`

export const RecipeCardWithClaimsTitle = ({
  title,
  spicinessLevel,
}: TRecipeCardWithClaimsTitle) => {
  const mappingArray = new Array(spicinessLevel).fill(null)
  const ariaLabel =
    spicinessLevel > 0 ? `${spicinessLevel.toString()} chilli icons` : null

  return (
    <Flex direction="row" data-testid="recipe-card-title-wrapper">
      <StyledMultiLine
        lines={2}
        variant="heading-sm"
        color={theme.colors.pepper}
        flexGrow={4}
        marginRight={6}
      >
        {title}
      </StyledMultiLine>
      {spicinessLevel > 0 && (
        <Flex
          aria-label={ariaLabel}
          flexGrow={1}
          mt={6}
          ml={6}
          justifyContent="center"
        >
          {mappingArray.map((_value, index) => (
            <Icon
              data-testid="chilli"
              type="chilli"
              size={20}
              // eslint-disable-next-line react/no-array-index-key
              key={`chilli ${index}`}
              color={theme.colors.pepper}
              marginLeft={-8}
            />
          ))}
        </Flex>
      )}
    </Flex>
  )
}
